export const toRealCiklus = (customCiklus) => {
  switch(customCiklus){
    case "Prvi": {
      return 1;
    }
    case "Drugi": {
      return 2;
    }
    default: {
      return null;
    }
  }
}